import {
  getConfigBoolean,
  getConfigNumber,
  getConfigString,
} from './RemoteConfigService';
import { REMOTE_CONFIG_KEYS, type RemoteConfigFlags } from '../../core/config/remoteConfigKeys';

export type { RemoteConfigFlags };

export function readRemoteConfigFlags(): RemoteConfigFlags {
  return {
    minAppVersion: getConfigString(REMOTE_CONFIG_KEYS.minAppVersion, '0.0.0'),
    devPanel: getConfigBoolean(REMOTE_CONFIG_KEYS.devPanel, true),
    phoneAuth: getConfigBoolean(REMOTE_CONFIG_KEYS.phoneAuth, false),
    aiAssist: getConfigBoolean(REMOTE_CONFIG_KEYS.aiAssist, true),
    rag: getConfigBoolean(REMOTE_CONFIG_KEYS.rag, true),
    liveSupport: getConfigBoolean(REMOTE_CONFIG_KEYS.liveSupport, true),
    auditExport: getConfigBoolean(REMOTE_CONFIG_KEYS.auditExport, false),
    cutoffWarningMinutes: getConfigNumber(REMOTE_CONFIG_KEYS.cutoffWarningMinutes, 5),
    maintenanceMode: getConfigBoolean(REMOTE_CONFIG_KEYS.maintenanceMode, false),
    ragTopK: getConfigNumber(REMOTE_CONFIG_KEYS.ragTopK, 5),
    ragMinScore: getConfigNumber(REMOTE_CONFIG_KEYS.ragMinScore, 0.08),
  };
}
